import { useQuery } from '@tanstack/react-query';
import type { TourRequest } from '../Types/Tours.types';
import { getTours } from '../Services/Tours.service';
import { toursQueryKeys } from '../Constants/queryKeys';
import { MAX_LIST_LIMIT } from '@/Shared/constants/listLimits';

/**
 * Every tour, or a filtered set.
 *
 * Asks for the maximum by default, for the same reason as {@link usePages}: the BFF listing
 * defaults to 10 items and this screen groups the whole result by BU.
 */
export const useTours = (params: TourRequest = {}) => {
  return useQuery({
    queryKey: toursQueryKeys.list(params),
    queryFn: () => getTours({ limit: MAX_LIST_LIMIT, ...params }),
  });
};
